var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":_vm.size,"tile":_vm.tile}},[_c('img',{attrs:{"src":_vm.thumbSrc,"alt":"avatar"}})])}
var staticRenderFns = []

export { render, staticRenderFns }